import { render } from "./Option.vue?vue&type=template&id=80d6cb94&scoped=true"
import script from "./Option.vue?vue&type=script&lang=ts"
export * from "./Option.vue?vue&type=script&lang=ts"

import "./Option.vue?vue&type=style&index=0&id=80d6cb94&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-80d6cb94"

export default script